export default {
  loginPage_00001: "We provide smart grid and EV infrastructure<br /> solutions that are tailor made for the North<br /> American grid.",
  loginPage_00002:'Please enter the login account',
  loginPage_00003:'Please enter the login password',
  loginPage_00004:'Login',
  loginPage_00005:'Not registered yet？',
  loginPage_00006:'Register',
  loginPage_00007:'Privacy statement',
  loginPage_00008:'The username and password cannot be empty',
  loginPage_00009:'login',
  login_00033: "Forgot password?",
}